import { PayloadAction } from '@reduxjs/toolkit';
import { ILocalization } from '../../core/interfaces/ILocalization';

export const LocalizationReducer = {
	setLanguage: (state: ILocalization, action: PayloadAction<ILocalization>) => {
		state.language = action.payload.language;
	},
	setCountry: (state: ILocalization, action: PayloadAction<ILocalization>) => {
		state.country = action.payload.country;
	},
	setIsLoadingLanguage: (
		state: ILocalization,
		action: PayloadAction<boolean>
	) => {
		state.isLoading = action.payload;
	},
	setLocalization: (
		state: ILocalization,
		action: PayloadAction<ILocalization>
	) => {
		state.country = action.payload.country;
		state.language = action.payload.language;
	},
};
